import React, { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { loadActivityMode, saveActivityMode, ACTIVITY_MODES, getActivityModeMeta } from '../utils/activityModeStorage';
import api from '../services/api';

const getMessageForActivity = (activityId) => {
  switch (activityId) {
    case 'electrician':
      return "Parfait. Ce logiciel est optimisé pour les électriciens indépendants. TVA bâtiment, acomptes, factures de situation… tout est prêt.";
    case 'plumber':
      return "Parfait. Ce logiciel est optimisé pour les plombiers indépendants. TVA bâtiment, acomptes, factures de situation… tout est prêt.";
    case 'construction':
      return "Parfait. Ce logiciel est optimisé pour les artisans du bâtiment. TVA bâtiment, acomptes, factures de situation… tout est prêt.";
    case 'freelance':
      return "Parfait. Un outil simple pour créer vos devis et factures en quelques clics, sans jargon comptable.";
    case 'beauty':
      return "Idéal pour facturer rapidement vos prestations sans dépendre d’une plateforme.";
    case 'other':
    default:
      return "Parfait. On va garder l’interface simple et efficace, et vous pourrez affiner vos réglages ensuite.";
  }
};

const ActivityOnboardingDialog = ({ open, onClose }) => {
  const existing = useMemo(() => loadActivityMode(), []);
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState(existing?.id || '');
  const selectedMeta = selected ? getActivityModeMeta(selected) : null;

  const handleSelect = (id) => {
    setSelected(id);
    setStep(2);
  };

  const handleActivate = async () => {
    if (!selected) return;

    const meta = getActivityModeMeta(selected);
    saveActivityMode({ id: selected, label: meta?.label || selected, presetCatalogId: meta?.presetCatalogId || 'services', updatedAt: new Date().toISOString() });
    window.dispatchEvent(new Event('activityModeUpdated'));

    try {
      await api.post('/analytics/onboarding/activity', { activity: selected });
    } catch {
      // best-effort
    }

    onClose?.();
  };

  const handleClose = () => {
    // Onboarding non-bloquant : on permet de fermer.
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>🎯 Quelle est votre activité ?</DialogTitle>
      <DialogContent>
        {step === 1 ? (
          <Stack spacing={1.5} sx={{ pt: 1 }}>
            {ACTIVITY_MODES.map((mode) => (
              <Button
                key={mode.id}
                variant="outlined"
                onClick={() => handleSelect(mode.id)}
                sx={{ justifyContent: 'flex-start', py: 1.2 }}
              >
                {mode.label}
              </Button>
            ))}
          </Stack>
        ) : (
          <Box sx={{ pt: 1 }}>
            <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
              {selectedMeta?.label || 'Votre activité'}
            </Typography>
            <Typography variant="body1">
              {getMessageForActivity(selected)}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
        {step === 2 ? (
          <Button variant="contained" onClick={handleActivate} disabled={!selected}>
            Activer
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default ActivityOnboardingDialog;
